import { onAuthStateChanged } from 'firebase/auth';
import { getBlob, ref as storageRef } from 'firebase/storage';
import { clearSurveyPhotoCache, configureSurveyPhotoResolver, notifySurveyPhotoRetry } from '@officehub/survey-capture';
import { auth, storage } from '../../config/firebase';

/** Upload cap is 10 MB; getBlob truncates (it does not refuse) past its limit, so the cap sits well above any real photo. */
const MAX_PHOTO_BYTES = 25 * 1024 * 1024;

let stopAuthWatch: (() => void) | null = null;

/**
 * Survey photos are stored as tokenless links a browser <img> cannot load (storage.rules need a signed-in employee).
 * Every survey photo is drawn from its bytes, read through the signed-in SDK (getBlob: an authenticated read that stamps no token;
 * getDownloadURL would mint a permanent one). When the signed-in user changes, what was read is forgotten and failed tiles retry.
 */
export function registerSurveyPhotoResolver(): void {
  configureSurveyPhotoResolver((path) => getBlob(storageRef(storage, path), MAX_PHOTO_BYTES));
  stopAuthWatch?.();
  stopAuthWatch = onAuthStateChanged(auth, () => {
    clearSurveyPhotoCache();
    notifySurveyPhotoRetry();
  });
}
